import { render, staticRenderFns } from "./edit-hood-modal.vue?vue&type=template&id=521584c6&lang=pug"
import script from "./edit-hood-modal.vue?vue&type=script&lang=js"
export * from "./edit-hood-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports